import { c as _c } from "react/compiler-runtime";
import { parseAsString, parseAsStringLiteral, useQueryStates } from 'nuqs';
import type { ViewMode } from '../store/types';
const VIEW_MODES = ['plan', 'tools', 'mcp', 'vaultProxies', 'norms', 'skills', 'credentials'] as const satisfies readonly ViewMode[];
const TOOL_FILTERS = ['all', 'enabled', 'notEnabled'] as const;
type ToolFilter = (typeof TOOL_FILTERS)[number];
const useBuilderNavigation = () => {
  const $ = _c(22);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = parseAsStringLiteral(VIEW_MODES).withDefault("plan");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      view: t0,
      node: parseAsString,
      toolFilter: parseAsStringLiteral(TOOL_FILTERS).withDefault("all"),
      toolSearch: parseAsString.withDefault(""),
      mcpFilter: parseAsStringLiteral(TOOL_FILTERS).withDefault("all"),
      mcpSearch: parseAsString.withDefault("")
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [params, setParams] = useQueryStates(t1);
  let t2;
  let t3;
  if ($[2] !== setParams) {
    t2 = mcpFilter => setParams({
      mcpFilter
    });
    t3 = mcpSearch => setParams({
      mcpSearch
    });
    $[2] = setParams;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  let t5;
  if ($[5] !== setParams) {
    t4 = toolFilter => setParams({
      toolFilter
    });
    t5 = toolSearch => setParams({
      toolSearch
    });
    $[5] = setParams;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  let t6;
  if ($[8] !== params.view || $[9] !== setParams) {
    t6 = view => setParams({
      view,
      ...(view !== "plan" && {
        node: null
      }),
      ...(view !== params.view && {
        toolFilter: null,
        toolSearch: null,
        mcpFilter: null,
        mcpSearch: null
      })
    });
    $[8] = params.view;
    $[9] = setParams;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== params.mcpFilter || $[12] !== params.mcpSearch || $[13] !== params.toolFilter || $[14] !== params.toolSearch || $[15] !== params.view || $[16] !== t2 || $[17] !== t3 || $[18] !== t4 || $[19] !== t5 || $[20] !== t6) {
    t7 = {
      viewMode: params.view,
      mcpFilter: params.mcpFilter,
      mcpQuery: params.mcpSearch,
      setMcpFilter: t2,
      setMcpQuery: t3,
      filter: params.toolFilter,
      query: params.toolSearch,
      setFilter: t4,
      setQuery: t5,
      setViewMode: t6
    };
    $[11] = params.mcpFilter;
    $[12] = params.mcpSearch;
    $[13] = params.toolFilter;
    $[14] = params.toolSearch;
    $[15] = params.view;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
};
export type { ToolFilter };
export default useBuilderNavigation;